import numberUtils from 'app/shared/utils/numberUtils';

const adSpendUtils = {
    getCoreProductInvoiceTotals(coreProductInvoiceModel = {}, isScreenMobile) {
        const totals = [];

        if (!isScreenMobile) {
            if (coreProductInvoiceModel.billableLeadCountAvailable) {
                totals.push(`Total Leads: ${coreProductInvoiceModel.totalLeads}`);
            }
            if (coreProductInvoiceModel.billableClickCountAvailable) {
                totals.push(`Total Clicks: ${coreProductInvoiceModel.totalClicks}`);
            }
            if (coreProductInvoiceModel.leaseCountAvailable) {
                totals.push(`Total Leases: ${coreProductInvoiceModel.totalLeases}`);
            }
            if (coreProductInvoiceModel.rocketshipAvailable) {
                totals.push(`Total Active Days: ${coreProductInvoiceModel.totalActiveDays}`);
            }
        }
        totals.push(`Total Spend: ${numberUtils.asCurrencyWithDefault(coreProductInvoiceModel.totalCost, '-')}`);
        return totals;
    },
    getBoostAdTotals(boostAdReport = {}) {
        const totals = [];
        totals.push(`Total Spend: ${numberUtils.asCurrencyWithDefault(boostAdReport.totalCost, '-')}`);
        return totals;
    },
};

module.exports = adSpendUtils;
